import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "clear"]

  connect() {
    this.timeout = null
    this.toggleClear()
  }

  search() {
    clearTimeout(this.timeout)
    this.toggleClear()
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 300)
  }

  clear() {
    this.inputTarget.value = ""
    this.toggleClear()
    this.element.requestSubmit()
  }

  toggleClear() {
    if (this.hasClearTarget) {
      this.clearTarget.classList.toggle("hidden", !this.inputTarget.value)
    }
  }
}
